module.exports = __webpack_public_path__ + "img/T2A_rc_21.a83d52c7.png";